module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_shield.95ab96bc.svg";